import axios from "axios";

// const environment = "dev";
const environment = "prod";

export const apiUrl =
  environment === "dev"
    ? "https://bossess-backend-e593ba220e57.herokuapp.com/"
    : "https://bossess-backend-e593ba220e57.herokuapp.com/";

export const axiosInstance = axios.create({
  baseURL: apiUrl,
});

axiosInstance.interceptors.request.use(
  function (config) {
    const Info = localStorage.getItem("info");
    if (Info) {
      config.headers["Authorization"] = "Bearer " + JSON.parse(Info)?.token;
    }
    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);
axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response?.status === 401) {
      // Clear any auth data
      localStorage.clear();
      sessionStorage.clear();

      // Redirect to login page
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);
